export const useAnalytic = () => {
  const { $ga4, $gtm, $fbPixel } = useNuxtApp()

  const fbPixelEvent = ({
    fbCategory = 'track',
    fbEvent,
    fbValue = {},
  }: {
    fbCategory?: string
    fbEvent: string
    fbValue?: Record<string, unknown>
  }) => {
    if (typeof $fbPixel?.fbq === 'function') {
      $fbPixel?.fbq(fbCategory, fbEvent, fbValue)
    }
  }
  const analyticPageView = (title: string, path: string) => {
    if ($ga4?.dataLayer) {
      $ga4?.dataLayer.push({
        event: 'page_view',
        page_title: title,
        page_location: path,
      })
    }
    if ($gtm?.proxy?.dataLayer) {
      $gtm.proxy.dataLayer.push({
        event: 'page_view',
        page_title: title,
        page_location: path,
      })
    }
  }

  const analyticEvent = (params: GoogleAnalyticParams) => {
    if ($gtm?.proxy?.dataLayer) {
      $gtm.proxy.dataLayer.push({
        event: params.ga4ActionName,
        event_category: 'general',
        event_label: params.ga4Label,
      })
    }
  }

  const ga4Event = (event: string, value: string) => {
    if ($ga4?.dataLayer) {
      $ga4?.dataLayer.push({
        event,
        value,
      })
    }
  }

  return {
    fbPixelEvent,
    ga4Event,
    analyticPageView,
    analyticEvent,
  }
}
